<div class="tab-wrapper">
  <div class="card">
    <div class="card-body">
      <h3 class="card-title">Audit Log</h3>
      <div>
        <table id="audit-log-table" class="table">
          <thead>
            <tr>
              <th class="sort" (click)="sortBy($event, 'recordDate')">Date/time changed</th>
              <th class="sort" (click)="sortBy($event, 'activity')">Information changed</th>
              <th class="sort" (click)="sortBy($event, 'attrName')">Field changed</th>
              <th>Original value</th>
              <th>New value</th>
              <th class="sort" (click)="sortBy($event, 'userId')">Changed by</th>
            </tr>
            <tr class="filter-row">
              <th></th>
              <th>
                <input
                  [(ngModel)]="filters.activityQuery"
                  (ngModelChange)="filterBy($event)"
                  class="form-control"
                  placeholder="Filter..." />
              </th>
              <th>
                <input
                  [(ngModel)]="filters.attrNameQuery"
                  (ngModelChange)="filterBy($event)"
                  class="form-control"
                  placeholder="Filter..." />
              </th>
              <th></th>
              <th></th>
              <th>
                <input
                  [(ngModel)]="filters.userIdQuery"
                  (ngModelChange)="filterBy($event)"
                  class="form-control"
                  placeholder="Filter..." />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let d of data">
              <td>{{ d.DateChanged | date: 'MM/dd/yyyy h:mma' }}</td>
              <td>{{ d.ActivityType }}</td>
              <td>{{ d.FieldNameChanged }}</td>
              <td>{{ d.OldValue }}</td>
              <td>{{ d.NewValue }}</td>
              <td>{{ d.ChangedBy }}</td>
            </tr>
          </tbody>
        </table>
        <lib-pagination [pagination]="pagination" (pageChanged)="loadPage($event)"></lib-pagination>
      </div>
    </div>
  </div>
</div>
